__turbopack_context__.v({
  "billable": "XAlMua_billable",
  "bookingInner": "XAlMua_bookingInner",
  "bookingInnerVisible": "XAlMua_bookingInnerVisible",
  "bookingPlaceholder": "XAlMua_bookingPlaceholder",
  "bookingPlaceholderGone": "XAlMua_bookingPlaceholderGone",
  "bookingSlot": "XAlMua_bookingSlot",
  "button": "XAlMua_button",
  "buttonDone": "XAlMua_buttonDone",
  "checkGlyph": "XAlMua_checkGlyph",
  "checkGlyphVisible": "XAlMua_checkGlyphVisible",
  "checkbox": "XAlMua_checkbox",
  "checkboxChecked": "XAlMua_checkboxChecked",
  "checklistLabel": "XAlMua_checklistLabel",
  "checklistLabelDone": "XAlMua_checklistLabelDone",
  "columns": "XAlMua_columns",
  "headerSlot": "XAlMua_headerSlot",
  "headerStat": "XAlMua_headerStat",
  "headerStatOut": "XAlMua_headerStatOut",
  "mention": "XAlMua_mention",
  "mentionAvatar": "XAlMua_mentionAvatar",
  "mentionIn": "XAlMua_mentionIn",
  "mentionMeta": "XAlMua_mentionMeta",
  "mentionName": "XAlMua_mentionName",
  "mentionTick": "XAlMua_mentionTick",
  "modal": "XAlMua_modal",
  "notifyCard": "XAlMua_notifyCard",
  "notifyIcon": "XAlMua_notifyIcon",
  "notifySlot": "XAlMua_notifySlot",
  "notifyVisible": "XAlMua_notifyVisible",
  "root": "XAlMua_root",
  "scrim": "XAlMua_scrim",
  "scrimVisible": "XAlMua_scrimVisible",
  "statusCol": "XAlMua_statusCol",
  "statusDot": "XAlMua_statusDot",
  "statusDotActive": "XAlMua_statusDotActive",
  "statusLabel": "XAlMua_statusLabel",
});
